import { TextFieldHelper } from "@goodgamestudios/core";
import { Poker2Model } from "../../../model/Poker2Model";
import { Poker2Dialog } from "../Poker2Dialog";

import Container = createjs.Container;
import MouseEvent = createjs.MouseEvent;

export class Poker2MailConfirmGiftDialog extends Poker2Dialog {
    public static NAME: string = "Poker2MailConfirmGiftDialog";

    constructor(disp: Container) {
        super(disp);
    }
    protected init(): void {
        super.init();
    }

    protected applyProperties(): void {
        this.mailDialog.btn_ok.label = Poker2Model.languageData.getTextById("generic_btn_okay");
        TextFieldHelper.changeTextFromatSizeByTextWidth(24, this.mailDialog.txt_title, Poker2Model.languageData.getTextById("dialog_pesentreminder_title"));
        TextFieldHelper.changeTextFromatSizeByTextWidth(12, this.mailDialog.txt_copy, Poker2Model.languageData.getTextById("dialog_shippingconfirmation_send"));
    }

    protected onClick(event: MouseEvent): void {
        super.onClick(event);
        if (event.target == this.mailDialog.btn_close || event.target == this.mailDialog.btn_ok)
            this.hide();
    }

    protected get mailDialog(): Library.PokerPopUps.Poker2MailConfirmGift {
        return this.disp as Library.PokerPopUps.Poker2MailConfirmGift;
    }
}
